module.exports = __webpack_public_path__ + "img/name-indicator.53f05f2e.svg";